/**
 * Root
 */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Offline } from 'react-detect-offline';

// Workspaces
import { Timekeeper } from '../../workspaces/redux-timekeeper';
import { ErrorBoundary } from '../../workspaces/redux-error-boundary';

// Components
import ConnectionSnackbar from '../../components/ConnectionSnackbar';
import ConnectionTracker from '../../components/ConnectionTracker';
import Notifier from './components/Notifier';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import SignInAsUser from './components/SignInAsUser';
import StoreSearchOnMount from './components/StoreSearchOnMount';
import ExitSubmitting from './components/ExitSubmitting';
import ErrorBoundaryAlert from '../../components/ErrorBoundaryAlert';
import ErrorModal from '../../components/ErrorModal';
import VersionChecker from './components/VersionChecker';
import ActiveSeasonAlert from 'components/ActiveSeasonAlert';

// Scenes
import Home from '../Home';
import Login from '../Login';
import ResetPassword from '../ResetPassword';
import SharedEvent from '../SharedEvent';
import StyleGuide from '../StyleGuide';

const { REACT_APP_API_URL } = process.env;
const pollingUrl = `${REACT_APP_API_URL}/v1/Status`;

interface Props {
    location: {
        hash?: string
    };
}

export class Root extends React.PureComponent<Props> {
    render() {
        const {
            location: { hash }
        } = this.props;

        if (hash) {
            return <SignInAsUser hash={hash} />;
        }

        return (
            <ErrorBoundary
                namespace="Root"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <ExitSubmitting />
                <Offline polling={{ url: pollingUrl }}>
                    <ConnectionTracker />
                </Offline>
                <ConnectionSnackbar />
                <Timekeeper />
                <Notifier />
                <StoreSearchOnMount />
                <VersionChecker />
                <ActiveSeasonAlert />
                <ErrorModal />
                <Switch>
                    <Route path="/style-guide" component={StyleGuide} />
                    <PublicRoute path="/login" component={Login} />
                    <PublicRoute
                        path="/reset-password"
                        component={ResetPassword}
                    />
                    <Route
                        path="/shared-job/:eventUuid"
                        component={SharedEvent}
                    />
                    <PrivateRoute path="/" component={Home} />
                </Switch>
            </ErrorBoundary>
        );
    }
}

export default Root;
